import React from "react";
import {Typography} from "antd";
const { Title } = Typography;
const medicalData = {
  age: "Patient age",
  gender: "Gender",
  PR1: "Recent clinical presentation 1",
  PR2: "Recent clinical presentation 2",
  PRD: "Duration of Recent clinical presentation",
  CC: "Chief complaint",
  HPI: "History of present illness",
  PMH: "Past medical history",
  FH: "Family history",
  DH: "Drug history (current and previous medications)",
  OH: "Occupational history",
  MS: "Marital status",
  SH: "Social history (smoking, alcohol, substance abuse, exercise, diet)",
  TH: "Recent travel history",
  Allergy: "Known allergies",
  Immunization: "Immunization history, vaccinations",
  MH: "Menstrual history (Females)",
  OBH: "Obstetric history (Females)",
  XH: "Sexual history",
  CCx: "Contraceptive history (Females)",
  DevH: "Developmental history (Pediatrics)",
  NBH: "Birth and neonatal history (Pediatrics)",
  Growth: "Growth and developmental milestones",
  VS: "Vital signs (temperature, blood pressure, pulse, respiratory rate, oxygen tension)",
  PE1: "Physical examination finding 1",
  PE2: "Physical examination finding 2",
  PE3: "Additional systemic examination findings (CV, Resp, Abdomen, Neuro, MSK, Skin)",
  NE: "Neurological examination findings",
  MSE: "Mental status examination (if relevant)",
  LAB: "Laboratory studies (CBC, electrolytes, LFT, RFT, coagulation, serology, urinalysis)",
  BM: "Bone marrow studies",
  CSF: "Cerebrospinal fluid studies",
  RAD: "Radiologic investigation (X-ray, MRI, CT, Ultrasound, PET/CT, etc.)",
  ECG: "Electrocardiogram",
  ECHO: "Echocardiogram",
  EEG: "Electroencephalogram",
  EMG: "Electromyography / Nerve conduction",
  Endo: "Endoscopic findings (upper GI endoscopy, colonoscopy, bronchoscopy)",
  PATH: "Pathology/biopsy findings",
  GEN: "Genetic/Molecular studies",
  IHC: "Immunohistochemistry studies",
  Micro: "Microbiology cultures/studies",
  IMM: "Immunology/autoimmune profile",
  FN: "Functional studies (pulmonary function tests, renal clearance tests)",
  TxHx: "Previous treatments received (medical, surgical, radiation, chemo)",
  Course: "Hospital course/progression",
  Outcome: "Patient outcome (if relevant for forensic/autopsy cases)",
  Autopsy: "Autopsy findings (gross and microscopic)"
}

const BulletCard = () => {
  return (
    <div className="max-w-4xl mx-auto p-6 text-white">
      <Title level={3} className="mb-3">Patient Medical Summary</Title>
      <ul className="space-y-2">
        {Object.entries(medicalData).map(([key, value]) => (
          <li key={key} className="flex items-start gap-2">
            <span className="text-blue-500 font-bold">•</span>
            <span>
              <strong>[{key.toUpperCase()}]</strong>: {value}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default BulletCard;
